// 授权校验相关接口-提供调用

import { API, http } from './index';

// 企微侧边栏获取页面配置签名
export const getSignature = data => http.get(API.auth.getSignature, data);
// 企微侧边栏用户登录
export const login = data => http.post(API.auth.login, data, { isToken: false, isNoMessage: true });
// 企微客户和CRM客户绑定
export const bindWechatToCrmCustomer = data => http.post(API.auth.bindWechatToCrmCustomer, data);
// 企微客户和CRM客户解除绑定
export const unbindWechatToCrmCustomer = data => http.post(API.auth.unbindWechatToCrmCustomer, data);
// 企微侧边栏校验企微客户是否绑定CRM客户
export const checkIfBindCustomer = data => http.get(API.auth.checkIfBindCustomer, data);




export default {
    login,
    getSignature,
    bindWechatToCrmCustomer,
    unbindWechatToCrmCustomer,
    checkIfBindCustomer,
};
